// components/system/SystemModalWrapper.jsx
import React, { useEffect, useState } from 'react';
import SystemUpgradeModal from './SystemUpgradeModal';



const SystemModalWrapper = () => {
const [isOpen, setIsOpen] = useState(false);
const [payload, setPayload] = useState(null); // optional data

// Listen for global open event
useEffect(() => {
const handleOpen = (event) => {
setPayload(event?.detail || null);
setIsOpen(true);
};

const handleClose = () => {
setIsOpen(false);
setPayload(null);
};

window.addEventListener('openSystemUpgradeModal', handleOpen);
window.addEventListener('closeSystemUpgradeModal', handleClose);

return () => {
window.removeEventListener('openSystemUpgradeModal', handleOpen);
window.removeEventListener('closeSystemUpgradeModal', handleClose);
};
}, []);

const handleClose = () => {
setIsOpen(false);
setPayload(null);
};

return (
<SystemUpgradeModal
isOpen={isOpen}
onClose={handleClose}
data={payload}
/>
);
};

export default SystemModalWrapper;
